import {
  Subtitle1,
  Subtitle2,
  Subtitle3,
  Subtitle4,
  Subtitle5,
  Subtitle6,
  Subtitle7,
  Subtitle8,
  Subtitle9,
  Subtitle10,
} from '@/components/atoms';
import { ReactElement, ReactNode } from 'react';

interface IProps {
  children: ReactNode;
  level: number;
  color?: string;
  whiteSpaceWrap?: boolean;
  ellipsis?: boolean;
}

const Subtitle = (props: IProps) => {
  const { level, children, color = 'gray-600', whiteSpaceWrap = false, ellipsis = false } = props;
  const subtitle: { [index: number]: ReactElement } = {
    '1': (
      <Subtitle1 color={color} whiteSpaceWrap={whiteSpaceWrap} ellipsis={ellipsis}>
        {children}
      </Subtitle1>
    ),
    '2': (
      <Subtitle2 color={color} whiteSpaceWrap={whiteSpaceWrap} ellipsis={ellipsis}>
        {children}
      </Subtitle2>
    ),
    '3': (
      <Subtitle3 color={color} whiteSpaceWrap={whiteSpaceWrap} ellipsis={ellipsis}>
        {children}
      </Subtitle3>
    ),
    '4': (
      <Subtitle4 color={color} whiteSpaceWrap={whiteSpaceWrap} ellipsis={ellipsis}>
        {children}
      </Subtitle4>
    ),
    '5': (
      <Subtitle5 color={color} whiteSpaceWrap={whiteSpaceWrap} ellipsis={ellipsis}>
        {children}
      </Subtitle5>
    ),
    '6': (
      <Subtitle6 color={color} whiteSpaceWrap={whiteSpaceWrap} ellipsis={ellipsis}>
        {children}
      </Subtitle6>
    ),
    '7': (
      <Subtitle7 color={color} whiteSpaceWrap={whiteSpaceWrap} ellipsis={ellipsis}>
        {children}
      </Subtitle7>
    ),
    '8': (
      <Subtitle8 color={color} whiteSpaceWrap={whiteSpaceWrap} ellipsis={ellipsis}>
        {children}
      </Subtitle8>
    ),
    '9': (
      <Subtitle9 color={color} whiteSpaceWrap={whiteSpaceWrap} ellipsis={ellipsis}>
        {children}
      </Subtitle9>
    ),
    '10': (
      <Subtitle10 color={color} whiteSpaceWrap={whiteSpaceWrap} ellipsis={ellipsis}>
        {children}
      </Subtitle10>
    ),
  };
  return subtitle[level];
};

export default Subtitle;
